import { createStepGuard } from '@/hooks/createStepGuard'
import {
  STEP_FALLBACK_ROUTE,
  STEP_PREREQUISITES,
} from '@/pages/RunReport/guards/runReportGuardConfig'
import { selectRunReport } from '@/store/api/RunReport/RunReport.selector'

export const useRunReportGuard = createStepGuard({
  selectSlice: selectRunReport,
  prerequisites: STEP_PREREQUISITES,
  fallbacks: STEP_FALLBACK_ROUTE,
})
